import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as _ from 'lodash';
import moment from 'moment';
import { clearPageInsights, getPageInsights } from 'redux/modules/reporting';
import { ScrollableRow, Spinner } from 'components';
import PageChart from './PageChart';
import { connect } from 'react-redux';
import * as styles from './Reports.scss';
var ReportingCharts = (_dec = connect(function (state) {
  return {
    organization: state.organization.current,
    theme: state.theme,
    pageInsightStats: state.reporting.pageInsightStats,
    pageInsightPaging: state.reporting.pageInsightPaging,
    selectedInsights: state.reporting.selectedInsights,
    insightPeriod: state.reporting.insightPeriod
  };
}, {
  getPageInsights: getPageInsights,
  clearPageInsights: clearPageInsights
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(ReportingCharts, _Component);

  var _super = _createSuper(ReportingCharts);

  function ReportingCharts() {
    var _this;

    _classCallCheck(this, ReportingCharts);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillMount", function () {
      _this.getPageInsights('LAST_7_DAYS', _this.props.selectedInsights.filter(function (i) {
        return i.metric !== 'page_fans';
      }).map(function (i) {
        return i.metric;
      }));

      _this.getPageInsights('LAST_7_DAYS', _this.props.selectedInsights.filter(function (i) {
        return i.metric === 'page_fans';
      }).map(function (i) {
        return i.metric;
      }), 'DAY');
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this.props.clearPageInsights();
    });

    _defineProperty(_assertThisInitialized(_this), "getPageInsights", function (period, types) {
      var aggregation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'DAY';

      var sa = _this.props.organization.SocialAccounts.filter(function (acct) {
        return acct.platform === 'Facebook page';
      })[0];

      return _this.props.getPageInsights(_this.props.organization.id, sa.id, types, aggregation, period);
    });

    _defineProperty(_assertThisInitialized(_this), "handleChartPeriodSwitch", function (period, insightType) {
      return _this.getPageInsights(period, [insightType], insightType === 'page_fans' ? 'DAY' : '');
    });

    return _this;
  }

  _createClass(ReportingCharts, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          pageInsightStats = _this$props.pageInsightStats,
          pageInsightPaging = _this$props.pageInsightPaging;
      var charts = /*#__PURE__*/React.createElement(Spinner, {
        center: true
      });

      if (pageInsightStats && !_.isEmpty(pageInsightStats)) {
        charts = this.props.selectedInsights.map(function (i) {
          if (pageInsightStats.hasOwnProperty(i.metric)) {
            var insight = pageInsightStats[i.metric][0];

            if (!insight || !insight.values) {
              return /*#__PURE__*/React.createElement(PageChart, {
                style: {
                  flex: '1 0 350px',
                  maxWidth: 350
                },
                metric: i.metric,
                label: i.label,
                data: [],
                theme: _this2.props.theme,
                onPeriodSwitch: _this2.handleChartPeriodSwitch
              });
            }

            var data = insight.values.map(function (v) {
              return {
                name: moment(v.end_time).subtract(1, 'day').format('M/D'),
                uv: v.value
              };
            });
            return /*#__PURE__*/React.createElement(PageChart, {
              metric: i.metric,
              style: {
                flex: '1 0 25%',
                marginBottom: 36,
                minWidth: 300,
                maxWidth: 800
              },
              label: i.label,
              data: data,
              theme: _this2.props.theme,
              onPeriodSwitch: _this2.handleChartPeriodSwitch
            });
          }

          return '';
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-around',
          minHeight: 335,
          position: 'relative'
        }
      }, charts);
    }
  }]);

  return ReportingCharts;
}(Component), _defineProperty(_class2, "propTypes", {
  organization: PropTypes.object.isRequired,
  pageInsightStats: PropTypes.object.isRequired,
  clearPageInsights: PropTypes.func.isRequired,
  getPageInsights: PropTypes.func.isRequired,
  selectedInsights: PropTypes.array.isRequired,
  pageInsightPaging: PropTypes.object.isRequired,
  theme: PropTypes.object
}), _temp)) || _class);
export default ReportingCharts;